<div class="{uiClasses}menu" part="menu">
  {#if sliding}
    <div class="indicator" part="indicator" style={getIndicatorPosition}></div>
  {/if}
  {#each item in items}
    <menu-item
      active={isCurrentValue value item}
      href={item.href}
      value={item.value}
      exportparts="item"
    >
      {#if item.icon}
        <ui-icon part="item-icon" icon={item.icon}></ui-icon>
      {/if}
      {#if item.label}
        <span part="item-label" class="label">{item.label}</span>
      {/if}
      {#if item.badge}
        <ui-label part="item-badge" outline badge>
          {item.badge}
        </ui-label>
      {/if}
    </menu-item>
  {else}
    {>slot}
  {/each}
</div>
